import { useQuery } from 'react-query';

import { useAppContext } from '@contexts/AppContext';
import { ContentType } from '@tracking';
import {
  BOOKMARK_STATUS_KEY,
  BookmarkableType,
  bookmarkStatusQueryKey,
  contentTypeToBookmarkableType,
  loadBookmarkStatus,
} from '@utils/backend-api/bookmarks';

export default function useBookmarks(contentType: ContentType, contentId: number, enabled = true) {
  const { initialCurrentUser } = useAppContext();
  const bookmarkableType = contentTypeToBookmarkableType(contentType);
  const userId = initialCurrentUser?.id;
  const isSubscriber = initialCurrentUser?.is_subscriber;
  const isEnabled = enabled && !!bookmarkableType && !!contentId && !!userId && isSubscriber;

  const queryKey = bookmarkableType
    ? bookmarkStatusQueryKey(userId, bookmarkableType, contentId)
    : [BOOKMARK_STATUS_KEY, userId, bookmarkableType, contentId];

  const { data, isLoading, isFetching, refetch } = useQuery(
    queryKey,
    () => loadBookmarkStatus(bookmarkableType as BookmarkableType, contentId),
    {
      enabled: isEnabled,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: false,
    }
  );

  return {
    isBookmarked: data?.bookmarked ?? false,
    bookmarkedAt: data?.bookmarked_at ?? null,
    isLoadingBookmarked: isLoading,
    isFetchingBookmarked: isFetching,
    refetchBookmarkStatus: refetch,
    bookmarkableType,
    isBookmarkStatusEnabled: isEnabled,
    userId,
  };
}
